/* eslint-disable */

const configs = {
  web: {
    title: 'リバティー業務管理ツール',
  },
  application: {
    base: '',
  },
  api: {
    // WebAPIのAPIキー
    apikey: 'eTmszHnFGKLOn4nNcIxZ',
    // 開発環境用
    //  baseURL: 'https://localhost:44383/',
    // 本番環境用
    // 1.x.x 旧バージョンのため使用しないでください（2.0.0への移行完了が確認できるまでは稼働させています)
    // baseURL: 'https://wp4n6jb3ch.execute-api.ap-northeast-1.amazonaws.com/Prod/',
    // 2.0.0
    baseURL: 'https://oaxdy6lnmj.execute-api.ap-northeast-1.amazonaws.com/Prod/',
    

    // ライセンス確認
    license: 'setting/license',
  },
  googlemap: {
    key: '',
    libraries: 'places',
    region: 'JP',
    language: 'ja',
  },
};

export default configs;
